// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loder_loaderContainer__n87La","loaderContainer2":"Loder_loaderContainer2__HUCoW","loader":"Loder_loader__Hh+vU","l5":"Loder_l5__Aqi1S"};